import LabelProvider from "core/components/label/LabelProvider";
import { filters } from "common/Labels/Refine";
import { Messages } from "common/Labels/Messages";

export default LabelProvider.create({
	FollowedUsers: {
		k: "topic.subs.title",
		v: "Followed Users"
	},

	SubscribedDiscussions: {
		k: "user.subs.title",
		v: "Subscribed Discussions"
	},

	NewPost: {
		k: "topic.new",
		v: "New Post"
	},

	ManageSubscriptions: {
		k: "forum.subs.manage",
		v: "Manage Subscriptions"
	},
	FavouriteTopics: {
		k: "favourite.subs.title",
		v: "Favourite Discussions"
	},

	SearchTopic: {
		k: "topic.search",
		v: "Search"
	},

	Followers : {
		k: "followers.user.subs.title",
		v: "Followers"
	},
	Feature: {
		k: "feature.show",
		v: "Feature"
	},
	FollowedForums:{
		k: "forum.subs.title",
		v: "Followed Forum"
	},
	...filters,
	...Messages
});



// WEBPACK FOOTER //
// ./src/panels/forum/Forms.labels.ts